import Common from '@/assets/js/common.js'
import Constants from '../../config.local.js'
import AccountingMixin from '@/mixins/Accounting.js'
import HorseMixin from '@/mixins/Horse.js'
import InvoiceMixin from '@/mixins/Invoice.js'
import HorseTransformer from '@/assets/js/dexie/transformers/HorseTransformer.js'


/** Colonnes numériques partagées pour les tableaux de contrats (offline et online). */
const CONTRACT_NUMBER_COLUMNS = [
    'articles',
    'fractions.total', 'fractions.reservation', 'fractions.ft',
    'fractions.solde1octobre', 'fractions.soldepv', 'fractions.solde', 'fractions.a_facturer',
    'fractions.facture_reservation.encaisse', 'fractions.facture_reservation.solde',
    'fractions.facture_ft.encaisse', 'fractions.facture_ft.solde',
    'fractions.facture_1octobre.encaisse', 'fractions.facture_1octobre.solde',
    'fractions.facture_pv.encaisse', 'fractions.facture_pv.solde',
    'fractions.facture_saillie.encaisse', 'fractions.facture_saillie.solde',
    'invoices_percentage', 'paillettes_ratio', 'doses_ratio', 'porteurs_parts',
]

var ContractMixin = {
    data() {
        return {
        }
    },
    computed: {
        /**
         * Colonnes numériques pour les tableaux de contrats.
         * @returns {Array<String>}
         */
        contractNumberColumns() {
            return CONTRACT_NUMBER_COLUMNS
        },
    },
    mixins: [AccountingMixin, HorseMixin, InvoiceMixin],
    methods: {
        getContractConfigsOnline: async function(filtres) {
            const params = Object.keys(filtres)
                .filter(key => filtres[key] !== undefined && filtres[key] !== null)
                .map(key => `${key}=${filtres[key]}`)
                .join('&')

            const url = Constants.CONTRACT_CONFIG_LIST_URL + "?licence_key="+Constants.USER_LICENCE_KEY + (params ? '&'+params : '')

            const result = await this.$request.request_get_api("ContractMixin::getContractConfigsOnline", url)
            .catch(error => {
                console.error("ContractMixin::getContractConfigsOnline => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },

        loadContractsConfig: async function(horse_id) {
            return this.getContractConfigsOnline({horse_id})
        },
        loadContractsConfigBySeason: async function(season_id) {
            return this.getContractConfigsOnline({season_id})
		},
        getContractsConfig: async function(contractconfig_id) {
            const configs = await this.getContractConfigsOnline({contractconfig_id})
            return configs.length > 0 ? configs[0] : null
        },
        getContractsConfigByStallionAndSeason: async function(horse_id, season_id) {
            return this.getContractConfigsOnline({horse_id, season_id})
		},
        getConditionsMonte: async function() {
            const url = Constants.CONTRACT_CONDITIONS_MONTE_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getConditionsMonte", url)
            .catch(error => {
                console.error("ContractMixin::getConditionsMonte => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },
		getConditionsMonteCaInvoice: async function() {
			const url = Constants.CONTRACT_CONDITIONS_CA_INVOICE_URL + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("ContractMixin::getConditionsMonteCaInvoice", url)
				.then(res => res.retour)
				.catch(e => {
					console.error("ContractMixin::getConditionsMonteCaInvoice => ERROR", e)
					return null
				})
		},
		setConditionsMonteCaInvoice: async function(condition_id, state) {
			const url = this.constructRoute(Constants.CONTRACT_CONDITIONS_SET_CA_INVOICE_URL, { condition_id }) + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_post_api("ContractMixin::getConditionsMonteCaInvoice", url, { state }, false)
				.then(res => res.retour)
				.catch(e => {
					console.error("ContractMixin::setConditionsMonteCaInvoice => ERROR", e)
					return null
				})
		},
        getContractConfigTypeMonte: async function(contractconfig_id) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_TYPE_MONTE_URL, {contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getContractConfigTypeMonte", url)
            .catch(error => {
                console.error("ContractMixin::getContractConfigTypeMonte => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },
        getContractConfigTypeMonteFromId: async function(contractconfigtypemonte_id) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_TYPE_MONTE_ID_URL, {contractconfigtypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getContractConfigTypeMonteFromId", url)
            .catch(error => {
                console.error("ContractMixin::getContractConfigTypeMonteFromId => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },
        getAllAvenantFromContract: async function(contract_id) {
            return this.getAllAvenant(contract_id)
        },
        getContractConfigConditionsOnline: async function(contractconfig_id, typemonte_id = null, conditions_id = null) {
            let url = this.constructRoute(Constants.CONTRACT_CONFIG_CONDITIONS_URL, {contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            if(typemonte_id) url += '&typemonte_id='+typemonte_id
            if(conditions_id) url += '&conditions_id='+conditions_id

            const result = await this.$request.request_get_api("ContractMixin::getContractConfigConditionsOnline", url)
            .catch(error => {
                console.error("ContractMixin::getContractConfigConditionsOnline => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },
        getTypeMonte: async function() {
            const url = Constants.CONTRACT_TYPE_MONTE_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getTypeMonte", url)
            .catch(error => {
                console.error("ContractMixin::getTypeMonte => ERROR", error)
                return null
            })

            if(!result) return []

            // contracttypemonte_label est une clé de traduction, traduite jusqu'ici par le transformer
            return result.retour.map(type_monte => ({
                ...type_monte,
                contracttypemonte_label: this.getTrad(type_monte.contracttypemonte_label)
            }))
        },

        addContractConfig: async function(horse_id, season_id) {
            const url = Constants.CONTRACT_CONFIG_ADD_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::addContractConfig", url, {horse_id, season_id}, false)
            .catch(error => {
                console.error("ContractMixin::addContractConfig => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
		},
		addContractConfigModel: async function(contractconfig_id, params) {
			const url = this.constructRoute(Constants.CONTRACT_CONFIG_MODEL, { contractconfig_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_post_api("ModelMixin::isLinkModelTiers", url, params, false)
			.catch(error => {
				console.error("ModelMixin::isLinkModelTiers => ERROR", error)
				return null
			})

			if(result) return result.retour
			return null
		},
        updateContractConfig: async function(contractconfig_id, fields) {
            const params = {
                contractconfig_fromnumber: fields.contractconfig_fromnumber,
                contractconfig_season: fields.contractconfig_season.id,
                contractconfig_paillette: fields.contractconfig_paillette,
                contractconfig_paillette_recommended: fields.contractconfig_paillette_recommended,
                contractconfig_default_cmep: (Object.keys(fields.cmep).length > 0) ? fields.cmep.tiers_id : null,
                contractconfig_configuration: (fields.contractconfig_configuration && fields.contractconfig_configuration.checkdepositconfiguration_id) ? fields.contractconfig_configuration.checkdepositconfiguration_id : null,
                numbertemplate_prefix: fields.contractconfig_prefix.numbertemplate_prefix,
                numbertemplate_pattern: fields.contractconfig_prefix.numbertemplate_pattern
            }

            const url = this.constructRoute(Constants.CONTRACT_CONFIG_SAVE_URL, {contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::updateContractConfig", url, params, false)
            .catch(error => {
                console.error("ContractMixin::updateContractConfig => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },
		updateContractConfigConditionAvailableCa: async function(contractconfigtypemonte_id, available) {
			const url = this.constructRoute(Constants.CONTRACT_CONFIG_TYPE_MONTE_CA_URL, {contractconfigtypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_post_api("ContractMixin::updateContractConfigConditionAvailableCa", url, { available }, false)
			.catch(error => {
				console.error("ContractMixin::updateContractConfigConditionAvailableCa => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},
		updateContractConfigGlobalConditionAvailableCa: async function(contractconfigglobaltypemonte_id, available) {
			const url = Constants.CONTRACT_CONFIG_GLOBAL_SWITCH_CA + "?licence_key="+Constants.USER_LICENCE_KEY

			const params = {
				contractconfigglobaltypemonte_id: contractconfigglobaltypemonte_id,
				available: available
			}

			const result = await this.$request.request_post_api("ContractMixin::sendMailContracts", url, params, false)
			.catch(error => {
				console.error("ContractMixin::updateContractConfigGlobalConditionAvailableCa => ERROR", error)
				return null
			})
            return result ? result.retour : null
		},
        archiveTypeMonte: async function (contractconfigtypemonte_id, archive) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_TYPE_MONTE_ARCHIVE_URL, {contractconfigtypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::archiveTypeMonte", url, { archive }, false)
            .catch(error => {
                console.error("ContractMixin::archiveTypeMonte => ERROR", error)
                return null
            })

            return result ? result.retour : null
        },
        deleteTypeMonte: async function(contractconfigtypemonte_id) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_TYPE_MONTE_ID_URL, {contractconfigtypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_delete_api("ContractMixin::deleteTypeMonte", url, {})
            .catch(error => {
                console.error("ContractMixin::deleteTypeMonte => ERROR", error)
                return null
            })

            return result ? result.retour : null
		},
		printContract: async function(contract_id, return_stream = false) {
            let contract = contract_id
            if(contract_id < 0){
                await this.$sync.force()
                contract = this.$sync.replaceWithReplicated('contract', contract_id)
            }
			const url = this.constructRoute(Constants.CONTRACT_PRINT_URL, { contract_id: contract }) + "?licence_key="+Constants.USER_LICENCE_KEY + "&return_stream=" + return_stream
			const result = await this.$request.request_get_api("ContractMixin::printContract", url)
			.catch(error => {
				console.error("ContractMixin::printContract => ERROR", error)
				return null
			})
            if(return_stream){
                return result
            }
            Common.base64ToPdf(result, "contract_" + contract + ".pdf")
            return true
		},
		printContractLot: async function(contract_ids) {
            for (let i = 0; i < contract_ids.length; i++) {
                if(contract_ids[i] < 0) {
                    await this.$sync.force()
                    contract_ids[i] = this.$sync.replaceWithReplicated('contract', contract_ids[i])
                }
            }

			const url = this.constructRoute(Constants.CONTRACT_PRINT_LOT_URL, { contract_ids: contract_ids.join(",") }) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("ContractMixin::printContractLot", url)
			.catch(error => {
				console.error("ContractMixin::printContractLot => ERROR", error)
				return null
			})
            Common.base64ToPdf(result, "contract_" + contract_ids.join(",") + ".pdf")
            return true
		},
		sendMailContracts: async function(contract_ids, model_id = null, commentaire = null, expeditor = null, courtierMail = null, mails_coproprios = null, insemination_center_mail= null, send_mail_sender = false, model_courtier = null, model_cmep = null, model_coproprios = null) {
			const url = Constants.CONTRACT_SEND_URL + "?licence_key="+Constants.USER_LICENCE_KEY

			const params = {
				contract_ids: contract_ids,
				model_id: model_id,
                expeditor: expeditor,
                commentaire: commentaire,
                courtier_mail: courtierMail,
                mails_coproprios: mails_coproprios,
                insemination_center_mail: insemination_center_mail,
                send_mail_sender: send_mail_sender,
                model_courtier: model_courtier,
                model_cmep: model_cmep,
                model_coproprios: model_coproprios
			}

			const result = await this.$request.request_post_api("ContractMixin::sendMailContracts", url, params, false)
			.catch(error => {
				console.error("ContractMixin::sendMailContracts => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},
		deleteContracts: async function(contract_ids) {
            const url = Constants.CONTRACT_DELETE_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            // Pas de catch : l'appelant attend une exception quand un contrat porte un article facturable
            const result = await this.$request.request_post_api("ContractMixin::deleteContracts", url, {contract_ids}, false)

            return result ? result.retour : null
		},
        addContractConditions: async function(contractconfig_id, conditions, articles, countries, cmep_ids) {
            return this.saveContractConfigConditions(contractconfig_id, null, conditions, articles, countries, cmep_ids)
        },
        editContractConditions: async function(contractconfigtypemonte_id, contractconfig_id, conditions, articles, countries, cmep_ids) {
            return this.saveContractConfigConditions(contractconfig_id, contractconfigtypemonte_id, conditions, articles, countries, cmep_ids)
        },
        saveContractConfigConditions: async function(contractconfig_id, contractconfigtypemonte_id, conditions, articles, countries, cmep_ids) {
            const params = {
                contractconfigtypemonte_id: contractconfigtypemonte_id,
                conditions: conditions,
                articles: articles,
                countries_available: countries,
                cmep_ids: cmep_ids
            }

            const url = this.constructRoute(Constants.CONTRACT_CONFIG_CONDITIONS_URL, {contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::saveContractConfigConditions", url, params, false)
            .catch(error => {
                console.error("ContractMixin::saveContractConfigConditions => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },
        addGlobalContractConditions: async function(season_id, contractconfigglobal_id, conditions, articles, countries, cmep_ids) {
            let params = {
                season_id: season_id,
                contractconfigglobal_id: contractconfigglobal_id,
                conditions: conditions,
                articles: articles,
                countries_available: countries,
                cmep_ids: cmep_ids
            }
            const url = this.constructRoute(Constants.CONDITIONS_GLOBAL_URL, params)+"?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_post_api("ContractMixin::addGlobalContractConditions", url, params, false)
				.then(res => res.retour)
				.catch(e => {
					console.error("ContractMixin::addGlobalContractConditions => ERROR", e)
					return null
				})
            
        },

        getContractPrefix: async function(contractconfig_id){
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_PREFIX_URL, {contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getContractPrefix", url)
            .catch(error => {
                console.error("ContractMixin::getContractPrefix => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        loadContracts: async function(horse_id) {
            const url = this.constructRoute(Constants.CONTRACT_MARE_AVENANTS_URL, {horse_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::loadContracts", url)
            .catch(error => {
                console.error("ContractMixin::loadContracts => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },

        getAllAvenant: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_AVENANTS_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getAllAvenant", url)
            .catch(error => {
                console.error("ContractMixin::getAllAvenant => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },


        getAvenantOfStallion: async function(horse_id) {
            const url = this.constructRoute(Constants.CONTRACT_STALLION_AVENANTS_URL, {stallion_id: horse_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getAvenantOfStallion", url)
            .catch(error => {
                console.error("ContractMixin::getAvenantOfStallion => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },

        getContractOnline: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_GET_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const response = await this.$request.request_get_api("ContractMixin::getContractOnline", url)
			.catch(error => {
				console.error("HorseMixin::getContractOnline => ERROR", error)
				return null
			})

			if(response) return response.retour
            return null
        },

        getContractsOnlineBatch: async function(contract_ids) {
            const url = this.constructRoute(Constants.CONTRACT_GET_BATCH_URL, { contract_ids: contract_ids.join(',') }) + "?licence_key=" + Constants.USER_LICENCE_KEY
            const response = await this.$request.request_get_api("ContractMixin::getContractsOnlineBatch", url)
            .catch(error => {
                console.error("ContractMixin::getContractsOnlineBatch => ERROR", error)
                return null
            })

            if(response) return response.retour
            return null
        },

        addContractOnline: async function(){
            const url = Constants.CONTRACT_ADD_URL + "?licence_key="+Constants.USER_LICENCE_KEY
			const response = await this.$request.request_get_api("ContractMixin::addContractOnline", url)
			.catch(error => {
				console.error("ContractMixin::addContractOnline => ERROR", error)
				return null
			})

            if(response) {
                return response.retour
            }
            return null
        },

        addContractOnlineFromHorse: async function(horse_id){
            if(horse_id < 0) {
                await this.$sync.force(false)
                horse_id = this.$sync.replaceWithReplicated('horse', horse_id)
            }
            const url = this.constructRoute(Constants.CONTRACT_ADD_FROM_HORSE_URL, {horse_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const response = await this.$request.request_get_api("ContractMixin::addContractOnlineFromHorse", url)
			.catch(error => {
				console.error("ContractMixin::addContractOnlineFromHorse => ERROR", error)
				return null
			})

            if(response) {
                return response.retour
            }
            return null
        },

        addContractOnlineFromTiers: async function(tiers_id){
            const url = this.constructRoute(Constants.CONTRACT_ADD_FROM_TIERS_URL, {tiers_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const response = await this.$request.request_get_api("ContractMixin::addContractOnlineFromTiers", url)
			.catch(error => {
				console.error("ContractMixin::addContractOnlineFromTiers => ERROR", error)
				return null
			})

            if(response) {
                return response.retour
            }
            return null
        },

        duplicateContractOnline: async function(contract_id){
            const url = this.constructRoute(Constants.CONTRACT_DUPLICATE_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const response = await this.$request.request_get_api("ContractMixin::duplicateContractOnline", url)
			.catch(error => {
				console.error("ContractMixin::duplicateContractOnline => ERROR", error)
				return null
			})

            if(response) {
                return response.retour
            }
            return null
        },

        getTransfertContractsForActe: async function(acte_id) {
            const url = this.constructRoute(Constants.CONTRACT_TRANSFERT_CONTRACTS_URL, { acte_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getTransfertContractsForActe", url)
            .catch(error => {
                console.error("ContractMixin::getTransfertContractsForActe => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        getPorteuseContractsForActes: async function(actes_ids) {
            const url = this.constructRoute(Constants.CONTRACT_PORTEUSE_CONTRACTS_URL, { actes_ids: actes_ids.join(',') }) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getPorteuseContractsForActes", url)
            .catch(error => {
                console.error("ContractMixin::getPorteuseContractsForActes => ERROR", error)
                return null
            })

            // Toujours renvoyer un tableau : les appelants alimentent directement une liste affichée
            if(result) return result.retour
            return []
        },

        assignPorteuseToAvenant: async function(avenant_id, porteuse_id) {
            const url = this.constructRoute(Constants.CONTRACT_ASSIGN_PORTEUSE_URL, { avenant_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::assignPorteuseToAvenant", url, { porteuse_id }, false)
            .catch(error => {
                console.error("ContractMixin::assignPorteuseToAvenant => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        duplicateContractWithPorteuse: async function(contract_id, porteuse_id) {
            const url = this.constructRoute(Constants.CONTRACT_DUPLICATE_PORTEUSE_URL, { contract_id, porteuse_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::duplicateContractWithPorteuse", url)
            .catch(error => {
                console.error("ContractMixin::duplicateContractWithPorteuse => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        saveTiersContract: async function(contract_id, tiers_id){
            const url = this.constructRoute(Constants.CONTRACT_TIERS_SAVE_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::saveTiersContract", url, {tiers_id}, false)
            .catch(error => {
                console.error("ContractMixin::saveTiersContract => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        getAvenantArticles: async function(avenant_id){
            avenant_id = this.$sync.replaceWithReplicated('contract_avenant', avenant_id)
            const url = this.constructRoute(Constants.CONTRACT_AVENANT_ARTICLES, {avenant_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getAvenantArticles", url)
            .catch(error => {
                console.error("ContractMixin::getAvenantArticles => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },

        getAvenantArticlesOnline: async function(avenant_id) {
            if(avenant_id < 0){
                await this.$sync.force(true)
                avenant_id = this.$sync.replaceWithReplicated('avenant_id', avenant_id)
            }

            const params = { 'avenant_id': avenant_id }
            const url = this.constructRoute(Constants.CONTRACT_AVENANT_ARTICLES, params) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixins::getAvenantArticlesOnline", url)
            .catch(error => {
                console.error("ContractMixins::getAvenantArticlesOnline => ERROR", error)
                return null
            })
            if(result) return result.retour
            return null
        },

        saveContractOnline: async function(contract_id, form, contractconfig_id, avenant_id, avenant_article, isDisabled, validation = false)
        {
            if((form.jument && form.jument.horse_id && form.jument.horse_id < 0) || (form.porteuse && form.porteuse.horse_id && form.porteuse.horse_id < 0)) {
                await this.$sync.force()
            }

            let contract = null
            if(!validation) {
                contract = {
                    ...((form.courtier && Object.keys(form.courtier).length > 0) && {contract_courtier: form.courtier.tiers_id}),
                    ...(form.contract_note !== undefined && {contract_note: form.contract_note}),
                    contract_contractconfig: contractconfig_id,
                    ...(form.paillette !== undefined && {contract_paillette: form.paillette}),
                    ...(form.contract_created !== undefined && {contract_created: form.contract_created})
                }
            }
            
            let contract_avenant = {
                avenant_id: avenant_id,
                ...(form.avenant_justification !== undefined && {avenant_justification: form.avenant_justification}),
                ...(form.avenant_comment !== undefined && {avenant_comment: form.avenant_comment}),
                ...((form.cmep && Object.keys(form.cmep).length > 0) && {avenant_cmep: form.cmep.tiers_id}),
                ...((form.transfert) && {avenant_centre_transfert: form.transfert}),
                ...(form.avenant_type !== undefined && {avenant_type: form.avenant_type}),
                ...((form.type_monte && form.type_monte.id !== undefined) && {avenant_typemonte: form.type_monte.id}),
                ...(form.avenant_free !== undefined && {avenant_free: form.avenant_free}),
                ...(form.avenant_dps !== undefined && {avenant_dps: form.avenant_dps}),
                ...(form.avenant_dn_bool !== undefined && {avenant_dn_bool: form.avenant_dn_bool}),
                ...(form.avenant_as_bool !== undefined && {avenant_as_bool: form.avenant_as_bool}),
                ...(form.avenant_revue_bool !== undefined && {avenant_revue_bool: form.avenant_revue_bool}),
                ...(form.avenant_dn !== undefined && {avenant_dn: form.avenant_dn}),
                ...((form.modele && form.modele.model_id !== undefined) && {avenant_model: form.modele.model_id}),
                // ...((form.jument && form.jument.horse_id !== undefined) && {avenant_horse: parseInt(this.$sync.replaceWithReplicated('horse', form.jument.horse_id))}),
                // ...((form.porteuse && form.porteuse.horse_id) && {avenant_porteuse: parseInt(this.$sync.replaceWithReplicated('horse', form.porteuse.horse_id))}),
                ...((form.jument_id) && {avenant_horse: form.jument_id}),
                ...((form.porteuse_id) && {avenant_porteuse: form.porteuse_id}),
                ...(form.signature_date && {avenant_date_signature: form.signature_date}),
                ...(form.validation_date && {avenant_date_validation: form.validation_date}),
                ...(form.type_contrat && {avenant_type_contrat: form.type_contrat}),
                ...((isDisabled && form.status !== undefined) && {avenant_status: form.status}),
                ...((!isDisabled) && {avenant_status: 1}),
                ...((form.avenant_transfert || !form.avenant_transfert) && {avenant_transfert: form.avenant_transfert}),
                ...((form.avenant_embryon || !form.avenant_embryon) && {avenant_embryon: form.avenant_embryon})
            }

            let params = {
                contract,
                contract_avenant,
                ...((!isDisabled && form.tiers_id) && {contract_tiers: form.tiers_id})
            }

            if(!validation) {
                params.avenants_articles = await this.saveAvenantArticlesV2(avenant_id, avenant_article, contract_id, false)
            }

            const url = this.constructRoute(Constants.CONTRACT_SAVE_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const response = await this.$request.request_post_api("ContractMixin::saveContractOnline", url, params, false)
			.catch(error => {
				console.error("ContractMixin::saveContractOnline => ERROR", error)
				return null
			})

			if(response) {
                return response.retour
            }
        },

        createAvenantOnline: async function(current_avenant_id, avenant_type, contract_id, contractconfig_id, infos, avenant_date, avenant_transfert, avenant_embryon) {
            const params = {
                avenant_type: avenant_type,
                contract_id: contract_id,
                contractconfig_id: contractconfig_id,
                infos: infos,
                avenant_date: avenant_date,
                avenant_transfert: avenant_transfert,
                avenant_embryon: avenant_embryon
            }

            const url = this.constructRoute(Constants.CONTRACT_AVENANT_ADD_URL, { 'avenant_id': current_avenant_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_post_api("ContractMixin::createAvenantOnline", url, params, false)
			.catch(error => {
				console.error("ContractMixin::createAvenantOnline => ERROR", error)
				return null
			})

			if(result) return result.retour
			return null
        },

        saveAvenantArticleComment: async function(contract_id, avenantarticles_id, comment){
            const params = { 'contract_id': contract_id, 'avenantarticles_id': avenantarticles_id }
            const url = this.constructRoute(Constants.CONTRACT_SAVE_AVENANT_ARTICLE_COMMENT, params) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::saveAvenantArticleComment", url, {
                avenantarticles_comment: comment,
            }, false)
            .catch(error => {
                console.error("ContractMixins::saveAvenantArticleComment => ERROR", error)
                return null
            })

            return result
        },

        getArticleForAuthor: async function(articles_id, author_tiers_id) {
            const url = Constants.CONTRACT_AUTHOR_ARTICLE_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::getArticleForAuthor", url, {articles_id, author_tiers_id}, false)
            .catch(error => {
                console.error("ContractMixin::getArticleForAuthor => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        saveAvenantArticlesV2: async function(avenant_id, conditions, contract_id, call_api = true){
            let avenant_articles_to_insert = []

            for (let i = 0; i < conditions.length; i++) {

                let articles_id = conditions[i].articles_id
                let author_id = conditions[i].initial_author
                //Je regarde si l'emetteur est le même que celui lié à l'article
                if(conditions[i].initial_author != conditions[i].author.tiers_id)
                {
                    author_id = conditions[i].author.tiers_id

                    // L'API duplique l'article et ses comptes comptables dans la compta de l'émetteur si besoin
                    const author_articles_id = await this.getArticleForAuthor(conditions[i].articles_id, author_id)
                    if(author_articles_id) {
                        articles_id = author_articles_id
                    }
                }

                //Je ne duplique pas les article deja facturé car sinon ils se retrouvent en double
                if(conditions[i].avenantarticles_invoiceable == 0) {
                    const contractconfigconditions_id = (conditions[i].contractconfigconditions_id != null) ? parseInt(conditions[i].contractconfigconditions_id) : null
                    const avenantarticles_type_condition = (conditions[i].avenantarticles_type_condition != null) ? parseInt(conditions[i].avenantarticles_type_condition) : null

                    let discount_value = conditions[i].avenantarticles_discount_value.toString().replace(',', '.').replace(/\s/g, '') * 100
                    let discount_type = (conditions[i].avenantarticles_discount_type) ? conditions[i].avenantarticles_discount_type.invoicediscounttype_id : null
                    if(discount_value == 0) {
                        discount_value = null
                        discount_type = null
                    }

                    //On recalcul le ttc ici pour pas avoir de soucis à l'envoi à l'api
                    const ht = parseFloat(conditions[i].avenantarticles_ht_hidden.toString().replace(' ', '').replace(',', '.')) * 100
                    const htunit_before = parseFloat(conditions[i].avenantarticles_htunit_before_discount_hidden.toString().replace(' ', '').replace(',', '.')) * 100
                    const ttc = ht * parseInt((1 + conditions[i].vat_value)*1000)

                    avenant_articles_to_insert.push({
                        // avenantarticles_id: Common.getNegativeId(),
                        avenantarticles_conditions: contractconfigconditions_id,
                        avenantarticles_article: parseInt(articles_id),
                        avenantarticles_tiers: parseInt(conditions[i].tiers.tiers_id),
                        avenantarticles_author: parseInt(author_id),
                        avenantarticles_avenant: parseInt(avenant_id),
                        avenantarticles_invoiceable: conditions[i].avenantarticles_invoiceable,
                        avenantarticles_ht: ht,
                        avenantarticles_ttc: parseInt(ttc/1000),
                        avenantarticles_valide: 1,
                        avenantarticles_type_condition: avenantarticles_type_condition,
                        avenantarticles_qte: conditions[i].avenantarticles_qte,
                        avenantarticles_quotepart: conditions[i].avenantarticles_quotepart.toString().replace(',', '.').replace(/\s/g, ''),
                        avenantarticles_ht_initial: (conditions[i].avenantarticles_ht_initial.toString().replace(',', '.').replace(/\s/g, '') * 100),
                        avenantarticles_htunit: (conditions[i].avenantarticles_htunit.toString().replace(',', '.').replace(/\s/g, '') * 100),
                        avenantarticles_htunit_before_discount: htunit_before,
                        avenantarticles_ht_before_discount: (conditions[i].avenantarticles_ht_before_discount.toString().replace(',', '.').replace(/\s/g, '') * 100),
                        avenantarticles_discount_type: discount_type,
                        avenantarticles_discount_value: discount_value,
                        avenantarticles_comment: conditions[i].avenantarticles_comment
                    })
                }
            }

            //Pour l'annulation de contrat par exemple, on doit supprimer les avenants articles
            if(call_api) {

                const params = { 'contract_id': contract_id, 'avenant_id': avenant_id }
                const url = this.constructRoute(Constants.CONTRACT_SAVE_AVENANT_ARTICLES, params) + "?licence_key="+Constants.USER_LICENCE_KEY
                const result = await this.$request.request_post_api("ContractMixins::saveAvenantArticles", url, {
                    avenants_articles: avenant_articles_to_insert,
                    delete_other: true,
                }, false)
                .catch(error => {
                    console.error("ContractMixins::saveAvenantArticles => ERROR", error)
                    return null
                })
            }
                
            return avenant_articles_to_insert
        },

        //Permet d'ajouter un article uniquement sur le contrat sans qu'il soit dans le contract config #bidouille
        addAvenantArticleSolo: async function(infos, contract_id){
            let ht = infos.ht.toString()
            ht = ht.replace(',', '.')
            ht = ht.replace(/\s/g, '')

            let ttc = infos.ttc.toString()
            ttc = ttc.replace(',', '.')
            ttc = ttc.replace(/\s/g, '')

            let avenant_articles_to_insert = []
            if(infos.horse_id) {
                const horse = await this.loadTiersCurrentPart(infos.horse_id)
                if(horse && horse.tiers_horse.length > 0) {
                    horse.tiers_horse.forEach(th => {
                        avenant_articles_to_insert.push({
                            avenantarticles_conditions: null,
                            avenantarticles_article: parseInt(infos.articles_id),
                            avenantarticles_tiers: parseInt(th.tiers.tiers_id),
                            avenantarticles_author: parseInt(infos.author_id),
                            avenantarticles_avenant: parseInt(infos.avenant_id),
                            avenantarticles_invoiceable: false,
                            avenantarticles_type_condition: infos.conditions,
                            avenantarticles_ht: (ht * 100) * (th.tiers_horse_part.tiershorsepart_contract / 100),
                            avenantarticles_ttc: (ttc * 100),
                            avenantarticles_valide: 1,
                            avenantarticles_qte: 1,
                            avenantarticles_htunit: (ht * 100),
                            avenantarticles_htunit_before_discount: (ht * 100) * (th.tiers_horse_part.tiershorsepart_contract / 100),
                            avenantarticles_ht_before_discount: (ht * 100),
                            avenantarticles_discount_type: null,
                            avenantarticles_discount_value: 0,
                            avenantarticles_comment: infos.comment,
                            avenantarticles_ht_initial: (ht * 100),
                            avenantarticles_quotepart: th.tiers_horse_part.tiershorsepart_contract
                        })
                    })
                }
                else {
                    avenant_articles_to_insert.push({
                        avenantarticles_conditions: null,
                        avenantarticles_article: parseInt(infos.articles_id),
                        avenantarticles_tiers: parseInt(infos.tiers_id),
                        avenantarticles_author: parseInt(infos.author_id),
                        avenantarticles_avenant: parseInt(infos.avenant_id),
                        avenantarticles_invoiceable: false,
                        avenantarticles_type_condition: infos.conditions,
                        avenantarticles_ht: (ht * 100),
                        avenantarticles_ttc: (ttc * 100),
                        avenantarticles_valide: 1,
                        avenantarticles_qte: 1,
                        avenantarticles_htunit: (ht * 100),
                        avenantarticles_htunit_before_discount: (ht * 100),
                        avenantarticles_ht_before_discount: (ht * 100),
                        avenantarticles_discount_type: null,
                        avenantarticles_discount_value: 0,
                        avenantarticles_comment: infos.comment
                    }) 
                }
            }
            else {
                avenant_articles_to_insert.push({
                    avenantarticles_conditions: null,
                    avenantarticles_article: parseInt(infos.articles_id),
                    avenantarticles_tiers: parseInt(infos.tiers_id),
                    avenantarticles_author: parseInt(infos.author_id),
                    avenantarticles_avenant: parseInt(infos.avenant_id),
                    avenantarticles_invoiceable: false,
                    avenantarticles_type_condition: infos.conditions,
                    avenantarticles_ht: (ht * 100),
                    avenantarticles_ttc: (ttc * 100),
                    avenantarticles_valide: 1,
                    avenantarticles_qte: 1,
                    avenantarticles_htunit: (ht * 100),
                    avenantarticles_htunit_before_discount: (ht * 100),
                    avenantarticles_ht_before_discount: (ht * 100),
                    avenantarticles_discount_type: null,
                    avenantarticles_discount_value: 0,
                    avenantarticles_comment: infos.comment
                })
            }

            const params = { 'contract_id': contract_id, 'avenant_id': infos.avenant_id }
            const url = this.constructRoute(Constants.CONTRACT_SAVE_AVENANT_ARTICLES, params) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::saveAvenantArticles", url, {
                avenants_articles: avenant_articles_to_insert,
                delete_other: false,
            }, false)
            .catch(error => {
                console.error("ContractMixins::saveAvenantArticles => ERROR", error)
                return null
            })

            return true
        },

        /**
         * Charge toutes les juments actives.
         */
        loadJuments: async function(){
            const result = await this.$storage.db.t('horse')
            .then(table => {
                return table
                    .where('horse_sexe')
                    .equals('F')
                    .and(h => h.horse_inactive == 0)
                    .transform(new HorseTransformer())
            })
            return Object.freeze(result)
        },

        loadAvenantType: async function(){
            const url = Constants.CONTRACT_AVENANT_TYPE_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::loadAvenantType", url)
            .catch(error => {
                console.error("ContractMixin::loadAvenantType => ERROR", error)
                return null
            })

            if(!result) return []

            // avenanttype_label est une clé de traduction, traduite jusqu'ici par le transformer
            return result.retour.map(avenant_type => ({
                ...avenant_type,
                avenanttype_label: this.getTrad(avenant_type.avenanttype_label)
            }))
        },

        loadContractArticlesAValiderV2: async function(contract_id) {

            const url = this.constructRoute(Constants.CONTRACT_AVENANT_ARTICLES_AVALIDER_GET_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const response = await this.$request.request_get_api("ContractMixin::loadContractArticlesAValiderV2", url)
			.catch(error => {
				console.error("ContractMixin::loadContractArticlesAValiderV2 => ERROR", error)
				return null
			})

			if(response) {
                return response.retour
            }
        },

        unsignContract: async function(avenant_id) {
            const url = this.constructRoute(Constants.CONTRACT_AVENANT_UNSIGN_URL, {avenant_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::unsignContract", url, {}, false)
            .catch(error => {
                console.error("ContractMixin::unsignContract => ERROR", error)
                return null
            })

            return result ? result.retour : null
        },

        signatureAvenantOnline: async function(avenant_id, signature_date, validation_date, type_contrat, avenant_dps) {
            const params = {
                signature_date: signature_date,
                validation_date: validation_date,
                type_contrat: type_contrat,
                avenant_dps: avenant_dps
            }

            const url = this.constructRoute(Constants.CONTRACT_AVENANT_SIGN_URL, { avenant_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::signatureAvenantOnline", url, params, false)
            .catch(error => {
                console.error("ContractMixins::signatureAvenantOnline => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        getContractNumber: async function(contract_id) {
            let contract = contract_id
            if(contract_id < 0){
                await this.$sync.force(true)
                contract = this.$sync.replaceWithReplicated('contract', contract_id)
            }
            const params = { 'contract_id': contract }
            const url = this.constructRoute(Constants.CONTRACT_NUMBER, params) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixins::getContractNumber", url)
            .catch(error => {
                console.error("ContractMixins::getContractNumber => ERROR", error)
                return null
            })
            if(result) return result.retour
            return null
        },

        loadSaisonMonte: async function(season_id, invoice, start, end) {
            const url = this.constructRoute(Constants.CONTRACT_BILAN_SAISON_URL, {season_id, start, end}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixins::loadSaisonMonte", url)
            .catch(error => {
                console.error("ContractMixins::loadSaisonMonte => ERROR", error)
                return null
            })
            if(result) return result.retour
            return null
        },

        savePartContract: async function(contract_id, saillie_id){
            let contract = contract_id
            if(contract_id < 0){
                await this.$sync.force(true)
                contract = this.$sync.replaceWithReplicated('contract', contract_id)
            }

            const params = { 'contract_id': contract, 'saillie_id': saillie_id }
            const url = this.constructRoute(Constants.CONTRACT_SAILLIE, params) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::savePartContract", url, params, false)
            .catch(error => {
                console.error("ContractMixins::savePartContract => ERROR", error)
                return null
            })
            if(result) return result.retour
            return null
        },

        freeSaillieContractv2: async function(contract_id){
            const params = {'contract_id': contract_id}
            const url = this.constructRoute(Constants.CONTRACT_SAILLIE_FREE, params) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::freeSaillieContractv2", url, params, false)
            .catch(error => {
                console.error("ContractMixins::freeSaillieContractv2 => ERROR", error)
                return null
            })

            if(result) return result.retour
            return null
        },

        getStatsContract: async function(horse_id, season_id = null){
            const url = this.constructRoute(Constants.CONTRACT_STATS_STALLION_URL, {stallion_id: horse_id, season_id: season_id || ''}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::getStatsContract", url)
            .catch(error => {
                console.error("ContractMixin::getStatsContract => ERROR", error)
                return null
            })

            if(result) return result.retour
            return { brouillon: 0, valides_signes: 0, without_contrats: 0 }
        },

		getCaContractInvoiceMode: async function() {
			const url = Constants.CONTRACT_CA_PRIVACY_POLICY_URL + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("ContractMixin::getCaContractInvoiceMode", url)
				.then(res => res.retour)
				.catch(e => {
					console.error("ContractMixin::getCaContractInvoiceMode => ERROR", e)
					return null
				})
		},
		getCaContractPrivacyPolicy: async function() {
			const url = Constants.CONTRACT_CA_PRIVACY_POLICY_URL + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("ContractMixin::getCaContractPrivacyPolicy", url)
				.then(res => res.retour.contract_privacy)
				.catch(e => {
					console.error("ContractMixin::getCaContractPrivacyPolicy => ERROR", e)
					return null
				})
		},

		getCaWelcomeMessage: async function() {
			const url = Constants.CONTRACT_CA_PRIVACY_POLICY_URL + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("ContractMixin::getCaWelcomeMessage", url)
				.then(res => ({
					welcome_message_fr: res.retour.welcome_message_fr || '',
					welcome_message_en: res.retour.welcome_message_en || '',
				}))
				.catch(e => {
					console.error("ContractMixin::getCaWelcomeMessage => ERROR", e)
					return { welcome_message_fr: '', welcome_message_en: '' }
				})
		},

		/**
		 * Récupère les informations "Contactez-nous" de la configuration CA.
		 * Retourne les textes FR/EN et le tableau des horaires d'ouverture (7 jours).
		 * @returns {Promise<{contactus_fr: string, contactus_en: string, openDays: string[]}>}
		 */
		getCaContactUs: async function() {
			const url = Constants.CONTRACT_CA_PRIVACY_POLICY_URL + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("ContractMixin::getCaContactUs", url)
				.then(res => {
					const days = res.retour.openDays
					return {
						contactus_fr: res.retour.contactus_fr || '',
						contactus_en: res.retour.contactus_en || '',
						openDays: Array.isArray(days) ? days : (days ? JSON.parse(days) : ['', '', '', '', '', '', '']),
					}
				})
				.catch(e => {
					console.error("ContractMixin::getCaContactUs => ERROR", e)
					return { contactus_fr: '', contactus_en: '', openDays: ['', '', '', '', '', '', ''] }
				})
		},

		/**
		 * Envoie un email de test de notification admin pour un contrat.
		 * @param {number|string} contract_id - ID du contrat
		 * @returns {Promise<Object>}
		 */
		sendTestCaAdminNotifMail: async function(contract_id) {
			const url = this.constructRoute(Constants.CONTRACT_CA_ADMIN_NOTIF_TEST_URL, { contract_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY

			return this.$request.request_post_api("ContractMixin::sendTestCaAdminNotifMail", url, {}, false)
				.then(res => res.retour)
		},

		/**
		 * Envoie un email de test de confirmation client pour un contrat.
		 * @param {number|string} contract_id - ID du contrat
		 * @param {string} [override_email] - Email de remplacement (optionnel)
		 * @returns {Promise<Object>}
		 */
		sendTestCaClientNotifMail: async function(contract_id, override_email = null) {
			const url = this.constructRoute(Constants.CONTRACT_CA_CLIENT_NOTIF_TEST_URL, { contract_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY

			const payload = override_email ? { override_email } : {}

			return this.$request.request_post_api("ContractMixin::sendTestCaClientNotifMail", url, payload, false)
				.then(res => res.retour)
		},

		markSendedContract: async function(contract_ids) {
            const url = Constants.CONTRACT_MARK_SENT_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::markSendedContract", url, {contract_ids}, false)
            .catch(error => {
                console.error("ContractMixin::markSendedContract => ERROR", error)
                return null
            })

            return result ? result.retour : null
		},
        loadConditionsGlobal: async function(season_id){
            const url = this.constructRoute(Constants.CONDITIONS_GLOBAL_URL, {season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			const result = await this.$request.request_get_api("ContractMixin::loadConditionsGlobal", url)
			.catch(error => {
				console.error("ContractMixin::loadConditionsGlobal => ERROR", error)
				return null
			})
			if(result) return result.retour
			return null
        },
        loadConditionsSeasonContractConfig: async function(season_id){
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_GLOBAL_URL, {season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			const result = await this.$request.request_get_api("ContractMixin::loadConditionsSeasonContractConfig", url)
			.catch(error => {
				console.error("ContractMixin::loadConditionsSeasonContractConfig => ERROR", error)
				return null
			})
			if(result) return result.retour
			return null
        },
        getStallionContractConfigFromGlobal: async function(contractconfigglobal_id, contractconfigglobaltypemonte_id){
            let url = null
            if(contractconfigglobaltypemonte_id) {
                url = this.constructRoute(Constants.CONTRACT_CONFIG_GLOBAL_STALLIONS_WITH_MONTE_URL, {contractconfigglobal_id, contractconfigglobaltypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            }
            else{
                url = this.constructRoute(Constants.CONTRACT_CONFIG_GLOBAL_STALLIONS_URL, {contractconfigglobal_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            }
			
			const result = await this.$request.request_get_api("ContractMixin::getStallionContractConfigFromGlobal", url)
			.catch(error => {
				console.error("ContractMixin::getStallionContractConfigFromGlobal => ERROR", error)
				return null
			})
			if(result) return result.retour
			return null
        },
        getConditionsFromGlobal: async function(contractconfigglobaltypemonte_id){
            const url = this.constructRoute(Constants.CONTRACT_GLOBAL_STALLIONS_CONDITIONS_URL, {contractconfigglobaltypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			const result = await this.$request.request_get_api("ContractMixin::getConditionsFromGlobal", url)
			.catch(error => {
				console.error("ContractMixin::getConditionsFromGlobal => ERROR", error)
				return null
			})
			if(result) return result.retour
			return null
        },
        getStallionTypeMonte: async function(contractconfigglobaltypemonte_id){
            const url = this.constructRoute(Constants.CONTRACT_GLOBAL_STALLIONS_TYPEMONTE_URL, {contractconfigglobaltypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			const result = await this.$request.request_get_api("ContractMixin::getConditionsFromGlobal", url)
			.catch(error => {
				console.error("ContractMixin::getConditionsFromGlobal => ERROR", error)
				return null
			})
			if(result) return result.retour
			return null
        },
        loadHorsesNotInContractConfig: async function(contractconfigglobal_id){
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_GLOBAL_NOT_HORSES, {contractconfigglobal_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			const result = await this.$request.request_get_api("ContractMixin::loadHorsesNotInContractConfig", url)
			.catch(error => {
				console.error("ContractMixin::loadHorsesNotInContractConfig => ERROR", error)
				return null
			})
			if(result) return result.retour
			return null
        },
        saveContractConfigGlobal: async function(season_id, form){
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_GLOBAL_URL, {season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			return this.$request.request_post_api("ContractMixin::saveContractConfigGlobal", url, {form}, false)
            .then(res => res.retour)
            .catch(e => {
                console.error("ContractMixin::saveContractConfigGlobal => ERROR", e)
                return null
            })
        },
        saveContractConfigGlobalConditionsStallions: async function(contractconfigglobal_id, form){
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_GLOBAL_STALLIONS_COND_URL, {contractconfigglobal_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			return this.$request.request_post_api("ContractMixin::saveContractConfigGlobal", url, {form}, false)
            .then(res => res.retour)
            .catch(e => {
                console.error("ContractMixin::saveContractConfigGlobal => ERROR", e)
                return null
            })
        },
        saveDistributionConditions: async function(contractconfigtypemonte_ids, contractconfigglobaltypemonte_id){
            const url = this.constructRoute(Constants.CONTRACT_GLOBAL_STALLIONS_CONDITIONS_URL, {contractconfigglobaltypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			return this.$request.request_post_api("ContractMixin::saveDistributionConditions", url, {contractconfigtypemonte_ids: contractconfigtypemonte_ids.split(',')}, false)
            .then(res => res.retour)
            .catch(e => {
                console.error("ContractMixin::saveDistributionConditions => ERROR", e)
                return null
            })
        },
        saveStallionToConditionsParent: async function(contractconfigglobaltypemonte_id, contractconfig_ids){
            const url = this.constructRoute(Constants.CONTRACT_GLOBAL_STALLIONS_DISTRIBUTE_URL, {contractconfigglobaltypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			return this.$request.request_post_api("ContractMixin::saveStallionToConditionsParent", url, {contractconfig_ids}, false)
            .then(res => res.retour)
            .catch(e => {
                console.error("ContractMixin::saveStallionToConditionsParent => ERROR", e)
                return null
            })
        },
        saveContractConfigStallionNumberTemplate: async function(elems){
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_NUMBER_TEMPLATE_URL, {}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			return this.$request.request_post_api("ContractMixin::saveContractConfigStallionNumberTemplate", url, {elems}, false)
            .then(res => res.retour)
            .catch(e => {
                console.error("ContractMixin::saveContractConfigStallionNumberTemplate => ERROR", e)
                return null
            })
        },
        createContractConfigFromGlobal: async function(horses, contractconfigglobal_id){
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_CREATE_FROM_GLOBAL, {contractconfigglobal_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			
			return this.$request.request_post_api("ContractMixin::saveContractConfigStallionNumberTemplate", url, {horses}, false)
            .then(res => res.retour)
            .catch(e => {
                console.error("ContractMixin::saveContractConfigStallionNumberTemplate => ERROR", e)
                return null
            })
        },
        deleteContractConfigFromGlobal: async function(contractconfigglobal_id, contractconfig_ids){
            const params = {contractconfig_ids: contractconfig_ids}
            
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_DELETE_FROM_GLOBAL, {contractconfigglobal_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			return this.$request.request_post_api("ContractMixin::saveContractConfigStallionNumberTemplate", url, params, false)
            .then(res => res.retour)
            .catch(e => {
                console.error("ContractMixin::saveContractConfigStallionNumberTemplate => ERROR", e)
                return null
            })
        },
        loadSeasonsOnline: async function(sortByDate = false) {
            const url = Constants.CONTRACT_SEASONS_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::loadSeasonsOnline", url)
            .catch(error => {
                console.error("ContractMixin::loadSeasonsOnline => ERROR", error)
                return null
            })

            if(!result) return []

            // Les dates étaient déjà converties par le transformer hors ligne
            const seasons = result.retour.map(season => ({
                ...season,
                season_start: Date.parseTz(season.season_start),
                season_end: Date.parseTz(season.season_end)
            }))

            if(sortByDate) {
                return seasons.sort((a, b) => a.season_start - b.season_start)
            }

            return seasons
        },

        loadSeasonOnline: async function(season_id) {
            const url = this.constructRoute(Constants.CONTRACT_SEASON_URL, { season_id }) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::loadSeasonOnline", url)
            .catch(error => {
                console.error("ContractMixin::loadSeasonOnline => ERROR", error)
                return null
            })

            if(!result) return null

            return {
                ...result.retour,
                season_start: Date.parseTz(result.retour.season_start),
                season_end: Date.parseTz(result.retour.season_end)
            }
        },

        loadSeasonByIdWithContractConfig: async function(season_id, light = false) {
            // Les écrans consommateurs ne lisent que season.contracts_config[].horse
            const contracts_config = await this.getContractConfigsOnline({season_id})

            return { season_id: parseInt(season_id), contracts_config }
        },

        fastEditContractv2: async function(contract_infos, avenant_infos) {
            let contract_id = contract_infos.contract_id
            const params = {
                contract_infos: contract_infos,
                avenant_infos: avenant_infos
            }

            const url = this.constructRoute(Constants.CONTRACT_FAST_SAVE_URL, { contract_id }) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_post_api("ModelMixin::fastEditContractv2", url, params, false)
			.catch(error => {
				console.error("ModelMixin::fastEditContractv2 => ERROR", error)
				return null
			})

			if(result) return result.retour
			return null
        },

        loadExportContract: async function(season_id) {
			const url = Constants.CONTRACT_EXPORT + "?licence_key="+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_post_api("ContractMixin::loadExportContract", url, {season_id: season_id}, false)
			.catch(error => {
				console.error("ContractMixin::loadExportContract => ERROR", error)
				return null
			})

			Common.csvToFile(result['lines'], result['name'] + "?" + result['extension'])
        },

        deleteExportContract: async function() {
        	const url = Constants.CONTRACT_EXPORT + "?licence_key="+Constants.USER_LICENCE_KEY

			const response = await this.$request.request_delete_api("ContractMixin::deleteExportContract", url, {})
			.catch(e => {
				console.error("ContractMixin::deleteExportContract", e)
				this.failureToast("toast.info_save_failed")
				return null
			})

            this.successToast()
			return response.retour
		},

        // DOCUMENT
        getDocumentByContract: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_DOCUMENT_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixins::getDocumentByContract", url)
            if(result) return result.retour
            return null
        },

        getUrlContractDocument(contract_id) {
            return this.constructRoute(Constants.CONTRACT_DOCUMENTS_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
        },

        addContractDocument: async function(contract_id, params) {
            const url = this.constructRoute(Constants.CONTRACT_DOCUMENT_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::getDocumentByContract", url, params, false)
            if(result) return result.retour
            return null
        },

        uploadDocumentContractFile: async function(contract_id, document_id, document_file) {
            const url = this.constructRoute(Constants.CONTRACT_DOCUMENT_FILE_URL, {contract_id, document_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            return this.$request.request_post_file_api("ContractMixins::uploadDocumentContractFile", url, [
                { 
                    name: 'document',
                    content: document_file
                }])
                .catch(e => {
                    console.error("ContractMixins::uploadDocumentContractFile => ERROR", e)
                    return null
                })
                .then(res => {
                    return res.retour
                })
        },

        editContractDocument: async function(contract_id, document_id, params) {
            const url = this.constructRoute(Constants.CONTRACT_DOCUMENT_BY_ID_URL, {contract_id, document_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::editContractDocument", url, params, false)
            if(result) return result.retour
            return null
        },
        createAvenantArticlesFromInvoiceDetails: async function(contract_id, details) {
            const url = this.constructRoute(Constants.CONTRACT_INVOICE_DETAILS_AVENANT_ARTICLES_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::createAvenantArticlesFromInvoiceDetails", url, {details}, false)
            if(result) return result.retour
            return null
        },
        delierInvoiceDetailsAvenantArticles: async function(contract_id, avenantarticles_id) {
            const url = this.constructRoute(Constants.CONTRACT_DELIER_INVOICE_DETAILS_AVENANT_ARTICLES_URL, {contract_id, avenantarticles_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixins::delierInvoiceDetailsAvenantArticles", url, {}, false)
            .catch(e => {
				console.error("ContractMixin::delierInvoiceDetailsAvenantArticles", e)
				this.failureToast("toast.info_save_failed")
				return null
			})

            this.successToast()
            if(result) return result.retour
            return null
        },

        deleteContractDocument: async function(contract_id, document_id) {
            const url = this.constructRoute(Constants.CONTRACT_DOCUMENT_BY_ID_URL, {contract_id, document_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_delete_api("ContractMixins::deleteContractDocument", url)
            if(result) return result.retour
            return null
        },

        saveContractVersion: async function(contract_id) {
            const url = this.constructRoute(Constants.CONTRACT_SAVE_VERSION_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixins::saveContractVersion", url)
            if(result) return result.retour
            return null
        },

        removeContractConfig: async function(contractconfig_id) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_URL, {contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_delete_api("ContractMixin::removeContractConfig", url, {})
            .catch(error => {
                console.error("ContractMixin::removeContractConfig => ERROR", error)
                return null
            })

            if(result && result.retour && result.retour.deleted === false) {
                this.failureToast('toast.has_contracts')
            }

            return result ? result.retour : null
        },

        printBlankContract: async function(contractconfig_id, model_id, condition_id, lang) {
            const params = {contractconfig_id, model_id, condition_id, lang}
            const url = this.constructRoute(Constants.CONTRACT_BLANK_PDF_URL, params) + "?licence_key="+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_post_api("ContractMixin::printBlankContract", url, {}, false)
			.catch(error => {
				console.error("ContractMixin::printBlankContract => ERROR", error)
				this.failureToast("toast.info_save_failed")
				return null
			})

			if(result) Common.base64ToPdf(result, "contract_blank_" + contractconfig_id + ".pdf")
            return null
        },

        getCountContractsStatusByStallion: async function(stallion_id, season_id) {
            const url = this.constructRoute(Constants.CONTRACT_GET_CONTRACTS_STATUS_STALLION, {stallion_id, season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getCountContractsStatusByStallion", url)

            if(result) return result.retour
            return null
        },

        sendMailDocumentContract: async function(contract_id, documents, model_id = null, commentaire = null, expeditor = null, courtier_mail = null, mails_coproprios = null, insemination_center_mail= null, send_mail_sender = false ) {
            const url = Constants.CONTRACT_DOCUMENT_SEND_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const params = {
                contract_id,
                documents,
                model_id,
                expeditor,
                commentaire,
                courtier_mail,
                mails_coproprios,
                insemination_center_mail,
                send_mail_sender,
            }

            const result = await this.$request.request_post_api("ContractMixin::sendMailDocumentContract", url, params, false)
            .catch(error => {
                console.error("ContractMixin::sendMailDocumentContract => ERROR", error)
                return null
            })

            return result ? result.retour : null
        },

        getContractConfigInfos: async function(contractconfig_id) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_URL, {contractconfig_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContractConfigInfos", url)

            if(result) return result.retour
            return null
        },

        createContractLot: async function(contracts) {
            const url = Constants.CONTRACT_CREATE_LOT + "?licence_key="+Constants.USER_LICENCE_KEY

            return this.$request.request_post_api("ContractMixin::createContractLot", url, {contracts}, false)
                .then(res => res.retour)
                .catch(e => {
                    console.error("ContractMixin::createContractLot => ERROR", e)
                    return null
                })
        },

        printRelanceCentre: async function(tiers_id, model_id, contracts_ids, type) {
            const params = {contracts_ids, type}
            const url = this.constructRoute(Constants.CONTRACT_RELANCE_CENTRE, {tiers_id, model_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY
			const result = await this.$request.request_post_api("ContractMixin::printRelanceCentre", url, params, false)
			.catch(error => {
				console.error("ContractMixin::printRelanceCentre => ERROR", error)
				this.failureToast("toast.info_save_failed")
				return null
			})

			if(result) Common.base64ToPdf(result, this.getTrad('monte.relance_centre') + ".pdf")
            return null
        },

        getContractBySeasonMareStallion: async function(seasonmarestallions) {
            const url = this.constructRoute(Constants.CONTRACT_COUPLE_URL, {seasonmarestallion_ids: seasonmarestallions.join(',')}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getContractBySeasonMareStallion", url)

            if(result) return result.retour
            return null
        },

        deleteContractAvenantsArticles: async function(avenantarticles_ids, contract_ids) {
            const url = Constants.CONTRACT_AVENANT_ARTICLES_DELETE + "?licence_key="+Constants.USER_LICENCE_KEY

            return this.$request.request_post_api("ContractMixin::deleteContractAvenantsArticles", url, {avenantarticles_ids, contract_ids}, false)
                .then(res => res.retour)
                .catch(e => {
                    console.error("ContractMixin::deleteContractAvenantsArticles => ERROR", e)
                    return null
                })
        },

        /**
         * Récupère les contrats d'une saison, avec pagination serveur si tableParams fourni.
         * @param {Number} season_id - Identifiant de la saison
         * @param {Object|null} tableParams - Paramètres de pagination/tri/filtres (POST si présent, GET sinon)
         * @returns {Object|Array|null} Réponse paginée {data, total} ou tableau brut
         */
        getSeasonContract: async function(season_ids, tableParams = null) {
            const url = this.constructRoute(Constants.CONTRACTS_SEASON_URL, {season_id: season_ids.join(',')}) + "?licence_key="+Constants.USER_LICENCE_KEY

            let result
            if (tableParams) {
                result = await this.$request.request_post_api("ContractMixin::getSeasonContract", url, tableParams, false)
            } else {
                result = await this.$request.request_get_api("ContractMixin::getSeasonContract", url)
            }

            if(result) return result.retour
            return null
        },

        /**
         * Récupère les listes de filtres disponibles (étalons, clients, CMEP) pour une saison.
         * @param {Number} season_id - Identifiant de la saison
         * @returns {Object|null} { stallions: Array, clients: Array, cmeps: Array }
         */
        getSeasonFilters: async function(season_ids) {
            const url = this.constructRoute(Constants.CONTRACTS_SEASON_FILTERS_URL, {season_id: season_ids.join(',')}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::getSeasonFilters", url)
            if(result) return result.retour
            return null
        },

        deleteConditionsContractConfigGlobal: async function(contractconfigglobaltypemonte_id) {
            const url = this.constructRoute(Constants.CONTRACT_CONFIG_GLOBAL_URL, {season_id: contractconfigglobaltypemonte_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const response = await this.$request.request_delete_api("ContractMixin::deleteConditionsContractConfigGlobal", url, {})
            .catch(e => {
                console.error("ContractMixin::deleteConditionsContractConfigGlobal", e)
                return null
            })

            return response.retour
        },

        generateContractSignatureLink: async function(contract_id, params) {
            const url = this.constructRoute(Constants.CONTRACT_SEND_SIGNATURE_URL, {contract_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::generateContractSignatureLink", url, params, false)
            if(result) return result.retour
            return null
        },

        loadExportGlobalSeason: async function(season_id) {
            const url = this.constructRoute(Constants.CONTRACTS_EXPORT_SEASON_URL, {season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_get_api("ContractMixin::loadExportGlobalSeason", url)

            if(result) return result.retour
            return null
        },

        downloadExportGlobal: async function(season_id, filename) {
            const url = this.constructRoute(Constants.CONTRACTS_EXPORT_SEASON_DOWNLOAD_URL, {season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_post_api("ContractMixin::downloadExportGlobal", url, {filename}, false)
            .catch(error => {
                console.error("ContractMixin::downloadExportGlobal => ERROR", error)
                return null
            })

            Common.csvToFile(result['lines'], result['name'])
        },

        downloadNewExportGlobal: async function(season_id) {
            const url = this.constructRoute(Constants.CONTRACTS_EXPORT_SEASON_NEW_URL, {season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::downloadNewExportGlobal", url)
            .catch(error => {
                console.error("ContractMixin::downloadNewExportGlobal => ERROR", error)
                return null
            })

            Common.csvToFile(result['lines'], result['name'])
        },

        askExportSeason: async function(season_id) {
            const url = this.constructRoute(Constants.CONTRACTS_EXPORT_SEASON_URL, {season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::askExportSeason", url, null, false)

            if(result) return result.retour
            return null
        },

        checkDpsDuplicate: async function(contract_id, dps) {
            const url = Constants.CONTRACTS_CHECK_DPS_DUPLICATE_URL + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("ContractMixin::askExportSeason", url, {dps, contract_id}, false)

            if(result) return result.retour
            return null
        },

        loadCentreTransfert: async function() {
            const url = Constants.CONTRACT_CENTRES_TRANSFERT_URL + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("ContractMixin::loadCentreTransfert", url)
            .catch(error => {
                console.error("ContractMixin::loadCentreTransfert => ERROR", error)
                return null
            })

            if(result) return result.retour
            return []
        },

		/**
		 * Sauvegarde BATCH pour la commercialisation des contrats.
		 * 2 appels API parallèles :
		 *   1) POST ca_settings module=batch → privacy settings + invoice mode
		 *   2) POST contract/conditions/auto_invoice_ca/batch → conditions activées
		 * @param {Object} privacySettings - Paramètres de privacy policy
		 * @param {string} invoiceMode - Mode de facturation ('before' ou 'after')
		 * @param {Array} conditions - [{condition_id, state}, ...] pour toutes les conditions ciblées
		 * @returns {Promise<void>}
		 */
		saveCaContractCommercializationBatch: async function(privacySettings, invoiceMode, conditions) {
			const settingsUrl = Constants.CONTRACT_CA_PRIVACY_POLICY_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
			const conditionsUrl = Constants.CONTRACT_CONDITIONS_SET_CA_INVOICE_BATCH_URL + "?licence_key=" + Constants.USER_LICENCE_KEY

			const settingsPayload = {
				module: 'batch',
				values: JSON.stringify([
					{ module: 'contract_privacy', values: JSON.stringify(privacySettings) },
					{ module: 'contract_invoice_mode', values: invoiceMode },
				])
			}

			await Promise.all([
				this.$request.request_post_api("ContractMixin::saveCaContractCommercializationBatch#settings", settingsUrl, settingsPayload, false),
				this.$request.request_post_api("ContractMixin::saveCaContractCommercializationBatch#conditions", conditionsUrl, { conditions }, false),
			])
		},

		/**
		 * Sauvegarde BATCH pour la personnalisation des messages CA.
		 * 1 seul appel API : POST ca_settings module=batch → privacy + welcome + contact
		 * @param {Object} privacyData - Données de privacy (cgv, liens, conditions)
		 * @param {Object} welcomeData - {welcome_message_fr, welcome_message_en}
		 * @param {Object} contactData - {contactus_fr, contactus_en, openDays}
		 * @returns {Promise<void>}
		 */
		saveCaContractMessagesBatch: async function(privacyData, welcomeData, contactData) {
			const url = Constants.CONTRACT_CA_PRIVACY_POLICY_URL + "?licence_key=" + Constants.USER_LICENCE_KEY

			const payload = {
				module: 'batch',
				values: JSON.stringify([
					{ module: 'contract_privacy', values: JSON.stringify(privacyData) },
					{ module: 'welcome_message_fr', values: welcomeData.welcome_message_fr },
					{ module: 'welcome_message_en', values: welcomeData.welcome_message_en },
					{ module: 'contactus_fr', values: contactData.contactus_fr },
					{ module: 'contactus_en', values: contactData.contactus_en },
					{ module: 'openDays', values: JSON.stringify(contactData.openDays) },
				])
			}

			await this.$request.request_post_api("ContractMixin::saveCaContractMessagesBatch", url, payload, false)
		},
	}
}
export default ContractMixin
